import React from "react";
import {
  Badge,
  Box,
  HStack,
  Heading,
  Image,
  SimpleGrid,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import NavHeader from "../components/NavHeader";
import { Cookies } from "typescript-cookie";
import formatDate from "../lib/formatDate";
import Container from "../components/Container";
import AdminCard from "../components/accountComponents/AdminCard";

export default function Home() {
  const userCookie = Cookies.get("user");
  const user = JSON.parse(userCookie as string);

  return (
    <>
      <NavHeader label="Home" />

      <Box
        position={"absolute"}
        top={0}
        w={"calc(100% - 60px)"}
        h={"240px"}
        bg={"p.500"}
        zIndex={1}
      >
        <Image
          src={"/images/kubuPattern2.png"}
          h={"100%"}
          w={"100%"}
          objectFit={"cover"}
          opacity={0.1}
        />
      </Box>

      <Container gap={5} py={5} maxW={["540px", null, null, "1000px"]}>
        <VStack className="homeItemContainer" px={4}>
          <VStack
            bg={"var(--divider)"}
            backdropFilter={"blur(5px)"}
            borderRadius={"full"}
            mb={4}
            mx={"auto"}
            zIndex={3}
          >
            <Image
              src={
                user.image
                  ? `${process.env.REACT_APP_MEDIA_BASE_URL}${user.image}`
                  : "/images/defaultProfile.jpg"
              }
              boxSize={"300px"}
              w={"200px"}
              objectFit={"cover"}
              borderRadius={"full"}
              border={"1px solid var(--divider3)"}
            />
          </VStack>

          <VStack px={2}>
            <Heading textAlign={"center"} color={"p.500"} size="lg">
              {user.name}
            </Heading>
            <Text textAlign={"center"}>{user.email || "-"}</Text>
          </VStack>
        </VStack>

        <SimpleGrid columns={[1, null, null, 2]} gap={5}>
          <VStack className="homeItemContainer">
            <Heading as="h3" size={"md"} mb={2}>
              Detail Akun
            </Heading>

            <HStack gap={4}>
              <Text className="profileLabel">ID</Text>
              <Text>:</Text>
              <Text flex={1} textAlign={"right"}>
                {user.id}
              </Text>
            </HStack>

            <HStack gap={4}>
              <Text className="profileLabel">Username</Text>
              <Text>:</Text>
              <Text flex={1} textAlign={"right"}>
                {user.username}
              </Text>
            </HStack>

            <HStack gap={4}>
              <Text className="profileLabel">Nama</Text>
              <Text>:</Text>
              <Text flex={1} textAlign={"right"}>
                {user.name || "-"}
              </Text>
            </HStack>

            <HStack gap={4}>
              <Text className="profileLabel">Email</Text>
              <Text>:</Text>
              <Tooltip label={user.email}>
                <Text flex={1} textAlign={"right"} noOfLines={1}>
                  {user.email || "-"}
                </Text>
              </Tooltip>
            </HStack>

            <HStack gap={4}>
              <Text className="profileLabel">Telepon</Text>
              <Text>:</Text>
              <Text flex={1} textAlign={"right"}>
                {user.phone || "-"}
              </Text>
            </HStack>

            <HStack gap={4}>
              <Text className="profileLabel">Dibuat</Text>
              <Text>:</Text>
              <Text flex={1} textAlign={"right"}>
                {formatDate(user.created_at)}
              </Text>
            </HStack>
          </VStack>

          <VStack className="homeItemContainer">
            <Heading as="h3" size={"md"} mb={2}>
              Akses Admin
            </Heading>

            <HStack gap={4}>
              <Text className="aksesAdminLabel">Account</Text>
              <Text>:</Text>
              <Badge
                ml={"auto"}
                colorScheme={user.roles.adminAccount ? "green" : "red"}
                className="badge"
              >
                {user.roles.adminAccount ? "Ya" : "Tidak"}
              </Badge>
            </HStack>

            <HStack gap={4}>
              <Text className="aksesAdminLabel">CMS Landing Page</Text>
              <Text>:</Text>
              <Badge
                ml={"auto"}
                colorScheme={user.roles.adminCmsLandingpage ? "green" : "red"}
                className="badge"
              >
                {user.roles.adminCmsLandingpage ? "Ya" : "Tidak"}
              </Badge>
            </HStack>

            <HStack gap={4}>
              <Text className="aksesAdminLabel">Blog</Text>
              <Text>:</Text>
              <Badge
                ml={"auto"}
                colorScheme={user.roles.adminBlog ? "green" : "red"}
                className="badge"
              >
                {user.roles.adminBlog ? "Ya" : "Tidak"}
              </Badge>
            </HStack>

            <HStack gap={4}>
              <Text className="aksesAdminLabel">Course</Text>
              <Text>:</Text>
              <Badge
                ml={"auto"}
                colorScheme={user.roles.adminCourse ? "green" : "red"}
                className="badge"
              >
                {user.roles.adminCourse ? "Ya" : "Tidak"}
              </Badge>
            </HStack>
          </VStack>

          <VStack className="homeItemContainer">
            <Heading as="h3" size={"md"} mb={2}>
              Admin Card
            </Heading>

            <AdminCard data={user} />
          </VStack>
        </SimpleGrid>
      </Container>
    </>
  );
}
